//@ts-nocheck
// @ts-ignore
import { FEATURE_CUSTOM_PAYMENT, THEME_HASH } from "./constant";
// @ts-ignore
import { i18next } from "../base/i18n/index";
// @ts-ignore
import MAIN_LANG from "../../../lang/main.json";
import toast from "react-simple-toasts";
// @ts-ignore
import { showAppToast } from "../webjam/helper";
import axios from "axios";
// @ts-ignore
import { CURRENT_ROOM_NAME, Constant } from "../webjam/constant";
import { getBaseConfig, getStore } from "./Utils";
import languageDynamicLoader from "./languageDynamicLoader";
export const allowedDomainHash = {
    [THEME_HASH.rta]: "rta",
    [THEME_HASH.duet]: "duet",
    [THEME_HASH.mms]: "mms",
    [THEME_HASH.trmc]: "trmc",
};
export const currentHash = () => {
    let curHash = document.getElementsByTagName("html");
    if (curHash) {
        let hash = curHash[0].getAttribute("data-theme");
        if (hash) {
            return allowedDomainHash[hash];
        }
    }
    return "";
};
export const getBaseConfigI = (message) => {
    let parseMessage = i18next.t("rta-trmc.themeMessage." + currentHash() + "." + message);
    return parseMessage;
};
// custom translate
export const ct = (input, fromKey = "") => {
    let hasMessage = MAIN_LANG;
    if (fromKey) {
        if (fromKey == "messages" ||
            fromKey == "stripeMessage" ||
            fromKey == "messagesLabel") {
            input = "custom_v1." + input;
        }
    }
    if (input) {
        if (input.indexOf(".") != -1) {
            let splt = input.split(".");
            let mainMessage = hasMessage;
            let mainObj = "";
            // @ts-ignore
            splt.map((e) => {
                // @ts-ignore
                mainObj = mainMessage[e];
            });
            if (mainObj) {
                return i18next.t(mainObj);
            }
        }
    }
    let translated = i18next.t(input);
    translated = purifyText(translated);
    return translated;
};
// Custom Toast
export const customToast = (toastType, message, time) => {
    if (toastType == "showAppToast") {
        // @ts-ignore
        showAppToast(ct(message), time);
    }
    if (toastType == "toast") {
        // @ts-ignore
        toast(ct(message), time);
    }
};
async function getTranslatedText(data) {
    try {
        let resp = await axios({
            url: Constant.App.chatTranslate + "/translate-language",
            method: "POST",
            data,
        });
        if (resp.data) {
            return resp.data?.text;
        }
        return data.text;
    }
    catch (e) {
        return data.text;
    }
}
let mainsss = {};
export const dynamicMessageLocale = async (message) => {
    let myCurrentLanguage = i18next.language;
    let willMove = true;
    // let mainLang : Object = MAIN_LANG_CN;
    let mainLang = {};
    let englishLanguage = ["en", "enGB", "hsb", "kab"];
    if (englishLanguage.includes(myCurrentLanguage)) {
        return message;
    }
    let k = message.replace(/\s/g, "_");
    let mesgKey = "subscriptionPackage." + k;
    if (i18next.exists(mesgKey)) {
        return i18next.t(mesgKey).replace("&#39;", "'");
    }
    else {
        // console.log("I will fetch message ",message,mesgKey)
    }
    try {
        mainLang = languageDynamicLoader.getLanguageTranslation();
    }
    catch (e) {
        console.log("mainLang error =>", e);
    }
    if (mainLang[message] != undefined) {
        willMove = false;
        let finalMessage = mainLang[message];
        return finalMessage;
    }
    if (willMove) {
        let resp = await getTranslatedText({
            language: myCurrentLanguage,
            text: message,
        });
        return resp;
    }
};
export const localeCalender = () => {
    let myCurrentLanguage = i18next.language || "en";
    let daysMonths = {
        en: {
            days: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
        },
        // zhōu
        zhCN: {
            days: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
            months: [
                "一月",
                "二月",
                "行进",
                "四月",
                "可能",
                "六月",
                "七月",
                "八月",
                "九月",
                "十月",
                "十一月",
                "十二月",
            ],
        },
    };
    const days = daysMonths[myCurrentLanguage] != undefined
        ? daysMonths[myCurrentLanguage]["days"]
        : daysMonths["en"]["days"];
    const months = daysMonths[myCurrentLanguage] != undefined
        ? daysMonths[myCurrentLanguage]["months"]
        : daysMonths["en"]["months"];
    const locale = {
        localize: {
            day: (n) => days[n],
            month: (n) => months[n],
        },
        formatLong: {
            date: () => "mm/dd/yyyy",
        },
    };
    return locale;
};
export const getParseLanguage = {
    "af": "af",
    "ar": "ar",
    "be": "be",
    "bg": "bg",
    "ca": "ca",
    "cs": "cs",
    "da": "da",
    "de": "de",
    "el": "el",
    "eo": "eo",
    "es": "es",
    "et": "et",
    "eu": "eu",
    "fa": "fa",
    "fi": "fi",
    "fr": "fr",
    "gl": "gl",
    "he": "he",
    "hi": "hi",
    "hr": "hr",
    "hu": "hu",
    "hy": "hy",
    "is": "is",
    "it": "it",
    "ja": "ja",
    "ko": "ko",
    "lt": "lt",
    "lv": "lv",
    "ml": "ml",
    "mn": "mn",
    "mr": "mr",
    "nl": "nl",
    "oc": "oc",
    "pl": "pl",
    "pt": "pt",
    "ptBR": "pt-BR",
    "ro": "ro",
    "ru": "ru",
    "sc": "sc",
    "sk": "sk",
    "sl": "sl",
    "sq": "sq",
    "sr": "sr",
    "sv": "sv",
    "te": "te",
    "tr": "tr",
    "uk": "uk",
    "vi": "vi",
    "zhCN": "zh-CN",
    "zhTW": "zh-TW"
};
// {
//   "en": "en",
//   "af": "af",
//   "ar": "ar",
//   "be": "be", // new
//   "bg": "bg",
//   "ca": "ca",
//   "zh": "zh-CN",
//   "cs": "cs",
//   "da": "da",
//   "de": "da",
//   "nl": "nl",
//   "fil": "fil",
//   "fi": "fi",
//   "fr": "fr",
//   "de": "de",
//   "el": "el",
//   "hi": "hi",
//   "hu": "hu",
//   "is": "is",
//   "id": "id",
//   "it": "it",
//   "ja": "ja",
//   "ko": "ko",
//   "lv": "lv",
//   "ms": "ms",
//   "nb": "nb",
//   "pl": "pl",
//   "pt": "pt",
//   "ro": "ro",
//   "ru": "ru",
//   "sr": "sr",
//   "sk": "sk",
//   "es": "es",
//   "sv": "sv",
//   "th": "th",
//   "tr": "tr",
//   "uk": "uk",
//   "vi": "vi",
//   "zhCN": "zh-CN",
//   "zhTW": "zh-TW"
// }
export const isValidRoomName = (room) => {
    if (!room.length)
        return false;
    let isValid = room.match(/[a-zA-Z0-9-_.:+]/gm);
    let willStop = false;
    if (!isValid) {
        willStop = true;
    }
    else if (isValid) {
        if (room.length != isValid.length) {
            willStop = true;
        }
    }
    if (willStop) {
        if (CURRENT_ROOM_NAME) {
            alert(ct("messages.invalidRoom", "messages"));
        }
        else {
            toast(ct("messages.invalidRoom", "messages"));
        }
    }
    return willStop;
};
export const allowedLanguages = [
    "af",
    "ar",
    "be",
    "bg",
    "ca",
    "cs",
    "da",
    "de",
    "el",
    "en",
    "enGB",
    "eo",
    "es",
    "esUS",
    "et",
    "eu",
    "fa",
    "fi",
    "fr",
    "frCA",
    "gl",
    "he",
    "hi",
    "hr",
    // "hsb",
    "hu",
    "hy",
    "is",
    "it",
    "ja",
    // "kab",
    "ko",
    "lt",
    "lv",
    "ml",
    "mn",
    "mr",
    "nl",
    // "oc",
    "pl",
    "pt",
    "ptBR",
    "ro",
    "ru",
    // "sc",
    "sk",
    "sl",
    "sq",
    "sr",
    "sv",
    "te",
    "tr",
    "uk",
    "vi",
    "zhCN",
    "zhTW",
];
export const expiredSubscription = ["past_due", "refunded"];
// Replace special entities code
const specialEntities = [
    { code: "&#39;", value: "'" },
    { code: "&#34;", value: '"' },
    { code: "&#160;", value: " " },
];
export const purifyText = (text) => {
    try {
        if (typeof text === "string") {
            let _text = text;
            for (let element of specialEntities) {
                if (text.includes(element.code)) {
                    var myRegExp = new RegExp(`${element.code}`, "i");
                    _text = text.replace(myRegExp, `${element.value}`);
                }
            }
            return _text;
        }
        return text;
    }
    catch (error) {
        return text;
    }
};
// Checking if user have subscription or Not
export const checkSubscription = () => {
    /*
    This function is used for checking user have subscription or not, if user have no subscription, Then we showing alert modal to user to buy subscription.
    It is handled by getBaseConfig method. variable name is hideAskSubscriptionModal
    if hideAskSubscriptionModal = false, then show modal if user have no subscription otherwise hide
    */
    if (getBaseConfig("hideAskSubscriptionModal")) {
        return true;
    }
    return getStore(FEATURE_CUSTOM_PAYMENT)?.userPaymentSubscription?.isActive;
};
export const getWebRoomName = (room) => {
    if (room && room.length) {
        // if (webRoomNamePrefix) {
        //   if (room.includes(webRoomNamePrefix)) {
        //     if (room.replace(webRoomNamePrefix, "").length > 1) {
        //       if (room.includes("/")) {
        //         if (room.indexOf("/") == 0) {
        //           room = room.replace("/" + webRoomNamePrefix, "")
        //         } else {
        //           room = room.replace(webRoomNamePrefix + "/", "")
        //         }
        //       } else {
        //         room = room.replace(webRoomNamePrefix, "");
        //       }
        //     }
        //   }
        // }
        console.log("my room list A ", room, "webRoomNamePrefix ", webRoomNamePrefix);
        if (room?.replace(/\//g, "") == webRoomNamePrefix) {
            console.log("my room list B ");
            return "";
        }
        if (room) {
            console.log("my room list C ", room);
            if (room[0] == "/")
                room = room.substring(1);
        }
        console.log("my room list D ", room);
    }
    return room;
};
export const setWebRoomName = (room) => {
    if (room.length) {
        if (webRoomNamePrefix) {
            if (room.indexOf(webRoomNamePrefix) == -1) {
                if (room?.indexOf("/") == 0) {
                    return webRoomNamePrefix + room;
                }
                else {
                    return webRoomNamePrefix + "/" + room;
                }
            }
        }
    }
    return room;
};
export const socialRoomsPage = "rooms";
export let webRoomNamePrefix;
// check if this code is being using in iframe or without iframe
if (window.self !== window.top) {
    console.log("webRoomNamePrefix  A");
    webRoomNamePrefix = "";
}
else {
    webRoomNamePrefix = socialRoomsPage;
    console.log("webRoomNamePrefix B");
}
// export const webRoomNamePrefix = "webjam";
export const getWebRoomOrigin = window.location.origin + (webRoomNamePrefix ? "/" + webRoomNamePrefix : "");
/**
 * Email validation function
 */
export const validateEmail = (mail) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true;
    }
    return false;
};
// update language
export const updateLanguage = (language = null) => {
    console.log("request to update language ===>", language);
    i18next.changeLanguage(language || 'en');
};
export const socialRedirSufix = "/OuIVuX07";
export const isIframe = window.self !== window.top;
const translateCache = new Map();
export const translateSubscription = async (data) => {
    function formateData(data) {
        let finalData = {};
        for (let i = 0; i < data.length; i++) {
            if (data[i].package_type != undefined) {
                if (finalData[data[i].package_type] == undefined) {
                    finalData[data[i].package_type] = [];
                }
                finalData[data[i].package_type].push(data[i]);
            }
        }
        return finalData;
    }
    async function titles() {
        data = await Promise.all(data.map(async (main) => {
            main.features = await Promise.all(main.features.map(async (feature) => {
                if (translateCache.has(feature.title)) {
                    // console.log("Has value ")
                    feature.title = translateCache.get(feature.title);
                }
                else {
                    let prev = { ...feature };
                    feature.title = await dynamicMessageLocale(feature.title);
                    // console.log("set  value ",prev.title,feature.title)
                    translateCache.set(prev.title, feature.title);
                }
                return feature;
            }));
            return main;
        }));
        return formateData(data);
    }
    async function description() {
        data = await Promise.all(data.map(async (main) => {
            main.features = await Promise.all(main.features.map(async (feature) => {
                feature.descriptions = await Promise.all(feature.descriptions.map(async (description) => {
                    if (translateCache.has(description)) {
                        return translateCache.get(description);
                    }
                    else {
                        let trans = await dynamicMessageLocale(description);
                        translateCache.set(description, trans);
                        return trans;
                    }
                }));
                return feature;
            }));
            return main;
        }));
        return formateData(data);
    }
    return {
        titles,
        description
    };
};
